export default (storeState, {payload}) => {
  let newState = Object.assign({}, storeState);
  newState.shopCategories = payload;

  return newState;
};
